import {Context} from '../../../../Helpers/Auth';
import SelectComponent from '../../../Selects/SelectComponent';
import React, {useContext, useState} from 'react';
import {useTranslation} from 'react-i18next';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

import {useHistory} from 'react-router-dom';
import {toast} from 'react-toastify';
import {useEffect} from 'react';
import {getLatituraLongiturFromPostalCode} from '../../../../pages/requests';

function Endereço({info}) {
    const {t} = useTranslation();
    const history = useHistory();
    const {
        paises,
        setMsgErroMoradas,
        leadMoradas,
        setLeadMoradas,

        leadMoradaID,
        setLeadMoradaID,
        leadMoradaPais,
        setLeadMoradaPais,
        leadMoradaMorada,
        setLeadMoradaMorada,
        leadMoradaCodigoPostal,
        setLeadMoradaCodigoPostal,
        leadMoradaCidade,
        setLeadMoradaCidade,
        leadMoradaContacto,
        setLeadMoradaContacto,
        leadMoradaDescricao,
        setLeadMoradaDescricao,
        leadMoradaEmail,
        setLeadMoradaEmail,
        leadMoradaEnderecoDefeito,
        setLeadMoradaEnderecoDefeito,

        editarLead,

        msgErroMoradas,

        setOnChangeForm,
    } = info;

    const [validacaoPais, setValidacaoPais] = useState(false);
    const [validacaoCP, setValidacaoCP] = useState(false);

    function EditarLinhaEnderecos(linha) {
        setLeadMoradaID(linha.id);
        setLeadMoradaPais(linha.pais);
        setLeadMoradaMorada(linha.morada);
        setLeadMoradaCodigoPostal(linha.codigoPostal);
        setLeadMoradaCidade(linha.cidade);
        setLeadMoradaContacto(linha.contacto);
        setLeadMoradaDescricao(linha.descricao);
        setLeadMoradaEmail(linha.email);
        setLeadMoradaEnderecoDefeito(linha.enderecoDefeito);
    }

    function atualizaMoradas() {
        if (leadMoradaID !== '') {
            setLeadMoradas(
                leadMoradas.map(m =>
                    m.id !== leadMoradaID
                        ? {
                              ...m,
                              enderecoDefeito: leadMoradaEnderecoDefeito ? false : m.enderecoDefeito,
                          }
                        : {
                              cidade: leadMoradaCidade,
                              codigoPostal: leadMoradaCodigoPostal,
                              descricao: leadMoradaDescricao,
                              enderecoDefeito: leadMoradaEnderecoDefeito,
                              id: leadMoradaID,
                              morada: leadMoradaMorada,
                              pais: leadMoradaPais,
                          },
                ),
            );
        }
    }
    useEffect(() => {
        if (leadMoradaID !== '') {
            atualizaMoradas();
        }
    }, [leadMoradaCidade, leadMoradaCodigoPostal, leadMoradaDescricao, leadMoradaEnderecoDefeito, leadMoradaID, leadMoradaMorada, leadMoradaPais]);

    useEffect(() => {
        if (leadMoradaPais?.value === 'PT' && new RegExp(/\d{4}(-)?\d{3}/).test(leadMoradaCodigoPostal)) {
            getLatituraLongiturFromPostalCode(leadMoradaCodigoPostal).then(res => {
                if (!leadMoradaCidade) setLeadMoradaCidade(res.data.Localidade);
                // if (!prospectMoradaLatitude) setProspectMoradaLatitude(res.data.centro[0]);
                // if (!prospectMoradaLongitude) setProspectMoradaLongitude(res.data.centro[1]);
            });
        }
    }, [leadMoradaCodigoPostal, leadMoradaPais]);

    console.log(leadMoradaPais, 'lead');

    function adicionarLinhaEnderecos() {
        //validar se pais e CP estão preenchidos
        if (!leadMoradaPais || leadMoradaCodigoPostal == '') {
            setValidacaoCP(true);
            setValidacaoPais(true);
            toast.warn(t('preenchaCamposLinhaE'), {
                position: 'top-right',
                autoClose: 6000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'light',
            });
            return;
        }

        const verificacaoLetras = leadMoradaCodigoPostal != '' ? /^[^a-zA-Z]*$/.test(leadMoradaCodigoPostal) : true;
        const verificacaoCarateres = leadMoradaCodigoPostal != '' ? /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(leadMoradaCodigoPostal) : false;

        // Verificar se o CP apenas contem digitos
        if (!verificacaoLetras || verificacaoCarateres) {
            setValidacaoCP(true);
            toast.warn(t('validacaoValor'), {
                position: 'top-right',
                autoClose: 6000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'light',
            });
            return;
        }

        debugger;

      // Obter o formato do código postal do país selecionado
    const formatoCodigoPostal = leadMoradaPais.formato;

    // Construir a expressão regular com base no formato do código postal
    const regexCodigoPostal = new RegExp(formatoCodigoPostal);

    // Validar o código postal de acordo com o formato do país
    if (!regexCodigoPostal.test(leadMoradaCodigoPostal)) {
        setValidacaoCP(true);
        toast.warn(t('validacaoCodPostal'), {
            position: 'top-right',
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
        });
        return;
    }

        // // Verificar se o CP tem 7 caracteres
        // if (leadMoradaCodigoPostal.length != 7 && leadMoradaCodigoPostal.length != 0) {
        //     setValidacaoCP(true);
        //     toast.warn(t('validacaoCodPostal'), {
        //         position: 'top-right',
        //         autoClose: 6000,
        //         hideProgressBar: false,
        //         closeOnClick: true,
        //         pauseOnHover: true,
        //         draggable: true,
        //         progress: undefined,
        //         theme: 'light',
        //     });
        //     return;
        // }

        // guarda a linha de endereço
        let x = leadMoradas
            .filter(e => e.id[0] == 'E')
            .map(e => Number(e.id.slice(1)))
            .sort()
            .reverse()[0];
        if (x == NaN || x == undefined) {
            x = 0;
        }
        setLeadMoradas([
            // outras moradas
            ...leadMoradas
                .filter(element => element.id != '')
                .map(m => {
                    return {
                        ...m,
                        enderecoDefeito: leadMoradaEnderecoDefeito ? false : m.enderecoDefeito,
                    };
                }),

            // novo endereço
            {
                id: 'E' + String(x + 1).padStart(3, '0'),
                pais: leadMoradaPais,

                morada: leadMoradaMorada,
                codigoPostal: leadMoradaCodigoPostal,
                cidade: leadMoradaCidade,
                enderecoDefeito: leadMoradas.length == 1 ? true : leadMoradaEnderecoDefeito,
                descricao: leadMoradaDescricao,
            },
            // linha Vazia
            {
                id: '',
                pais: null,

                morada: '',
                codigoPostal: '',
                cidade: '',
                enderecoDefeito: false,
                descricao: '',
            },
        ]);

        setLeadMoradaPais(null);
        setLeadMoradaMorada('');
        setLeadMoradaCodigoPostal('');
        setLeadMoradaCidade('');
        setLeadMoradaDescricao('');
        setLeadMoradaEnderecoDefeito(false);
    }

    useEffect(() => {
        const todosEnderecoDefeitoFalse = leadMoradas.every(objeto => !objeto.enderecoDefeito);

        if (todosEnderecoDefeitoFalse && leadMoradas.length > 0) {
            const novasLinhasEnderecos = [...leadMoradas];
            novasLinhasEnderecos[0].enderecoDefeito = true;
            setLeadMoradas(novasLinhasEnderecos);
        }
    }, [leadMoradas]);

    function EliminarLinhaEnderecos(linha) {
        setLeadMoradas(
            leadMoradas
                .filter(m => m.id !== linha.id || m.id === '')
                .map((m, i, a) => {
                    return {
                        ...m,
                        enderecoDefeito: i == 0 && !a.find(mm => mm.enderecoDefeito) ? true : m.enderecoDefeito,
                    };
                }),
        );

        setLeadMoradaPais(null);
        setLeadMoradaMorada('');
        setLeadMoradaCodigoPostal('');
        setLeadMoradaCidade('');
        setLeadMoradaDescricao('');
        setLeadMoradaEnderecoDefeito(false);
    }

    return (
        <>
            <div className="grid gap-6 mb-3 md:grid-cols-2">
                <div className="relative  overflow-x-auto shadow-md sm:rounded-[8px] z-0">
                    <table className="w-full  text-sm text-left text-gray-500 dark:text-gray-400">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300">
                            <tr>
                                <th scope="col" className="px-2 py-3">
                                    {t('codigoEndereco')}
                                </th>
                                <th scope="col" className="px-2 py-3">
                                    {t('pais')}
                                </th>
                                <th scope="col" className=" py-3">
                                    {t('descricao')}
                                </th>
                                <th scope="col" className=" py-3"></th>
                                <th scope="col" className=" py-3"></th>
                            </tr>
                        </thead>

                        <tbody>
                            {leadMoradas?.map(dados => (
                                <tr
                                    className="bg-white cursor-pointer border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700"
                                    onClick={() => {
                                        EditarLinhaEnderecos(dados);
                                    }}>
                                    <th scope="row" className="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                        {dados.id}
                                    </th>
                                    <th scope="row" className="px-2 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                        {dados.pais?.label}
                                    </th>

                                    <td className="px-2 py-1">
                                        <div className="flex flex-row items-center justify-between ">
                                            {dados.descricao ? dados.descricao : '-'}{' '}
                                            <div className="flex flex-row items-center">
                                                <div
                                                    disabled={!editarLead}
                                                    onClick={e => {
                                                        e.stopPropagation();
                                                        EliminarLinhaEnderecos(dados);
                                                    }}
                                                    className={` ml-2 hover:text-red-800 text-red-600 hover:dark:text-red-700 py-1 ${!editarLead ? 'disabled' : ''}`}>
                                                    <DeleteForeverIcon />
                                                </div>
                                                <div
                                                    onClick={e => {
                                                        e.stopPropagation();
                                                        EditarLinhaEnderecos(dados);
                                                        // setOnChangeForm(true);
                                                    }}
                                                    className="ml-2 hover:text-blue-800 text-blue-600 hover:dark:text-blue-700 py-1">
                                                    <SearchRoundedIcon />
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {msgErroMoradas && <small className="text-red-500">{msgErroMoradas}</small>}
                </div>
                <div className="grid gap-6 mb-3 md:grid-cols-2">
                    <div>
                        <label htmlFor="paises" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('pais')}*
                        </label>
                        <SelectComponent
                            isDisabled={!editarLead}
                            options={paises}
                            value={leadMoradaPais}
                            onChange={e => {
                                setLeadMoradaPais(e);
                                setOnChangeForm(true);

                                setValidacaoPais(false);
                            }}
                            noOptionsMessage={t('semopcoes')}
                            placeholder={t('selecioneOpcao')}
                        />
                        {validacaoPais ? <small className="text-red-500">{t('preenchaCampos')}</small> : null}
                    </div>
                    <div>
                        <label htmlFor="endereco" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('endereco')}
                        </label>
                        <input
                            type="text"
                            id="endereco"
                            className={` border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                !editarLead ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'
                            }`}
                            value={leadMoradaMorada}
                            maxLength={50}
                            required
                            onChange={e => {
                                setOnChangeForm(true);
                                setLeadMoradaMorada(e.target.value);
                            }}
                            disabled={!editarLead}
                        />
                    </div>
                    <div>
                        <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('codigoPostal')}*
                        </label>
                        <input
                            type="text"
                            id="phone"
                            // maxLength={7}
                            className={`border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                validacaoCP ? 'is-invalid-class dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500' : ''
                            }${!editarLead ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'}`}
                            placeholder="ex: 4900123"
                            required
                            value={leadMoradaCodigoPostal}
                            onChange={e => {
                                setValidacaoCP(false);
                                setOnChangeForm(true);
                                setLeadMoradaCodigoPostal(e.target.value);
                            }}
                            disabled={!editarLead}
                        />
                    </div>
                    <div>
                        <label htmlFor="cidade" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('cidade')}
                        </label>
                        <input
                            type="tel"
                            id="cidade"
                            value={leadMoradaCidade}
                            maxLength={40}
                            className={` border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                !editarLead ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'
                            }`}
                            required
                            disabled={!editarLead}
                            onChange={e => {
                                setOnChangeForm(true);
                                setLeadMoradaCidade(e.target.value);
                            }}
                        />
                    </div>
                    <div className=" col-span-2 mb-3">
                        <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('descricao')}
                        </label>

                        <textarea
                            disabled={!editarLead}
                            id="message"
                            rows="1"
                            maxLength={250}
                            value={leadMoradaDescricao}
                            onChange={e => {
                                setLeadMoradaDescricao(e?.target?.value);
                                setOnChangeForm(true);
                            }}
                            className={`block p-2.5 w-full text-sm text-gray-900 rounded-[8px] border border-gray-300 focus:ring-blue-500 focus:border-blue-500  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                !editarLead ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'
                            } `}
                            placeholder={t('escrevaDescricao')}></textarea>
                    </div>
                    <div className="flex items-center mb-4">
                        <input
                            onChange={e => {
                                setLeadMoradaEnderecoDefeito(e.target.checked);
                                setOnChangeForm(true);
                            }}
                            id="default-checkbox"
                            type="checkbox"
                            value=""
                            checked={leadMoradaEnderecoDefeito}
                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                        />
                        <label htmlFor="default-checkbox" className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                            {t('enderecoDefeito')}
                        </label>
                    </div>
                    {leadMoradaID == '' && (
                        <div className="flex flex-row justify-end">
                            <button
                                id="adicionarLinha"
                                type="button"
                                onClick={() => {
                                    adicionarLinhaEnderecos();
                                    setMsgErroMoradas('');
                                }}
                                className=" flex items-center text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-[8px] text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                {t('registarMorada')}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}

export default Endereço;
